import React, { useState, Fragment } from 'react'
import { Text } from 'theme-ui'

import { useResponsiveValue } from '@theme-ui/match-media'

import { ACCOUNTS_TABS_SLIDER_CFG as config } from '../../Sliders/config'
import { Transition } from 'react-transition-group'

import {
  TabsStyled,
  TabsInnerStyled,
  TabsNavigationStyled,
  TabsNavigationItemStyled,
  TabsNavigationItemIconStyled,
  TabsContentStyled,
  TabsContentContainerStyled,
  TabsContentItemStyled,
  TabsNavigationItemContentStyled
} from './styles'
import { AccountsTabsProps } from './types'
import PriceBoxList from '../../PriceBoxList'
import { transitionStyles } from './../cfg'
import StaticImage from './../../../atoms/ImageStatic'
import Slider from '../../Sliders'

const AccountsTabs: React.FC<AccountsTabsProps> = ({ data }) => {
  const isDesktop = useResponsiveValue([false, true, true, true], {
    defaultIndex: 0
  })
  const initValue = data[0].title
  const [isActive, setIsActive] = useState(initValue)

  const handleClick = (value: string): void => {
    setIsActive(value)
  }

  const tabsNavigationTemplate = data.map(({ tabKey, tabIcon, title, code }) => {
    const isTabActive = isActive === title
    return (
      <TabsNavigationItemStyled
        key={tabKey}
        onClick={() => handleClick(title)}
        isActive={isTabActive}
        aria-hidden={!isTabActive}
        type="button"
      >
        <TabsNavigationItemContentStyled>
          {tabIcon && (
            <TabsNavigationItemIconStyled>
              <StaticImage image={tabIcon} />
            </TabsNavigationItemIconStyled>
          )}
          <Text
            as="p"
            sx={{
              variant: 'bodyMontserrat15',
              fontFamily: 'secondary'
            }}
          >
            {title}
          </Text>
          {code && (
            <Text
              sx={{
                variant: 'bodyMontserrat16',
                fontFamily: 'secondary',
                marginTop: '2px',
                marginLeft: ['', '', '5px'],
                marginRight: ['', '', '5px'],
                display: ['block', '', 'inline']
              }}
            >
              ({code})
            </Text>
          )}
        </TabsNavigationItemContentStyled>
      </TabsNavigationItemStyled>
    )
  })

  return (
    <TabsStyled>
      <TabsInnerStyled>
        <TabsNavigationStyled as="div">
          {isDesktop ? <Slider {...{ config }}>{tabsNavigationTemplate}</Slider> : <Fragment>{tabsNavigationTemplate}</Fragment>}
        </TabsNavigationStyled>
        <TabsContentStyled as="div" variant="inners.primary">
          {data.map(({ tabKey, title, item }) => {
            const isTabActive = isActive === title
            return (
              <TabsContentContainerStyled key={`${tabKey}-tab`} isActive={isTabActive} aria-hidden={!isTabActive}>
                <Transition in={isTabActive} timeout={150} appear>
                  {(state) => (
                    <TabsContentItemStyled
                      style={{
                        ...transitionStyles[state]
                      }}
                    >
                      <PriceBoxList data={item} />
                    </TabsContentItemStyled>
                  )}
                </Transition>
              </TabsContentContainerStyled>
            )
          })}
        </TabsContentStyled>
      </TabsInnerStyled>
    </TabsStyled>
  )
}

export default AccountsTabs
